module.exports = __webpack_public_path__ + "static/media/silicon_to_system_journey.63225f95.pdf";